module.exports = __webpack_public_path__ + "f1f4ecea.woff";